export const getOptionalElement = <T extends HTMLElement>(
  selector: string,
  node: ParentNode = document
): T | undefined => node.querySelector<T>(selector) || undefined;

export const getElement = <T extends HTMLElement>(
  selector: string,
  node: ParentNode = document
): T => {
  const el = getOptionalElement<T>(selector, node);

  if (typeof el === 'undefined')
    throw new ReferenceError(
      `Missing element: expected "${selector}" to be present`
    );

  /* Return element */
  return el;
};

export const getPageTrackingData = () => {
  const pageFirstParentSectionEl = document.querySelector(
    '#page-parent-section-1'
  ) as HTMLDivElement;
  const pageSecondParentSectionEl = document.querySelector(
    '#page-parent-section-2'
  ) as HTMLDivElement;
  const pageThirdParentSectionEl = document.querySelector(
    '#page-parent-section-3'
  ) as HTMLDivElement;

  return {
    sourcetype: 'Documentation',
    context: pageFirstParentSectionEl?.dataset?.pageParentSection,
    sub_context: pageSecondParentSectionEl?.dataset?.pageParentSection,
    page_name: pageThirdParentSectionEl?.dataset?.pageParentSection,
    page_title: document.title,
    url: window.location.href,
    fragment: window.location.pathname,
  };
};
